module.exports = __webpack_public_path__ + "img/hardyGrip1.1a3fb40a.png";